// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3pllI","fileBtn":"File_fileBtn__1AlSS","closeBtn":"File_closeBtn__3WUS8","fileSelected":"File_fileSelected__AGOqZ","disabled":"File_disabled__1VhIZ"};